// extracted by mini-css-extract-plugin
export default {"EmbedDialog":"pr9Dv","EmbedDialog__copyButton":"PqbrB","EmbedDialog__copyButton--copied":"xASxx"};